import { useState } from "react";

const Input = ({ label, value, placeholder, onChange, isValid, validationMessage, maxlength, hidden, tooltip }) => {
    const [isInputFocused, setIsInputFocused] = useState(false);
    const tooltipId = `input-tooltip-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    const handleFocus = () => {
        setIsInputFocused(true);
    };

    const handleBlur = () => {
        setIsInputFocused(false);
    };

    if (hidden) {
        return null; // Render nothing if hidden is true
    }

    return (
        <>
            <div className="px-5 mb-5">
                <div>
                    <div className="flex items-center gap-1">
                        <p className={`text-md opacity-90 ${isInputFocused ? "text-blue-600" : "text-blue-950"}`}>{label}</p>
                        {tooltip && (
                            <span className="group relative inline-flex">
                                <button
                                    type="button"
                                    className="inline-flex cursor-help items-center border-0 bg-transparent p-0 text-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
                                    aria-label={`More information about ${label}`}
                                    aria-describedby={tooltipId}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M12 11v5" />
                                        <path d="M12 8h.01" />
                                    </svg>
                                </button>
                                <span
                                    className="pointer-events-none invisible absolute bottom-full left-1/2 z-50 mb-2 w-56 -translate-x-1/2 rounded-md bg-gray-800 px-3 py-2 text-xs font-normal leading-relaxed text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100"
                                    id={tooltipId}
                                    role="tooltip"
                                >
                                    {tooltip}
                                </span>
                            </span>
                        )}
                    </div>
                    <input
                        type="text"
                        placeholder={placeholder ?? label}
                        maxLength={maxlength}
                        className="w-full border-x-0 border-t-0 border-gray-300 focus:border-blue-600 text-md pl-0 py-2"
                        value={value}
                        onChange={onChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        style={{'borderBottom': !isValid ? '1px solid red' : ''}}
                    />
                    {!isValid && <p className="text-xs text-red-500 italic">{validationMessage}</p>}
                </div>
            </div>
        </>
    );
};

export default Input;
